import React, { useEffect } from 'react';
import { setSubpage } from '../../../routes/routerSlice';
import { CalculationDetailSubpages } from '../../Calculations/calculationsLib';
import { Helmet } from 'react-helmet-async';
import { MainContent, MainContentWrapper, Section } from '@ydistri/ds';
import { Spin } from 'antd';
import SectionRequestList from './SectionRequestList';
import RequestListStatisticsGuard from './RequestListStatisticsGuard';
import { useAppDispatch } from '../../../store';
import { useGetCalculationConfigurationQuery } from '../../../apis/apiGlobalConfiguration';
import { useTemplateOrCalculationWithValue } from '../../../hooks/useTemplateOrCalculationWithValue';

const CalculationRequestListStatistics: React.FC = () => {
  const dispatch = useAppDispatch();
  const templateOrCalculation = useTemplateOrCalculationWithValue();

  const { data: calculationConfigurationData, isFetching } = useGetCalculationConfigurationQuery(
    templateOrCalculation.value,
  );

  const requestList = calculationConfigurationData?.ptRequestListEntityList;

  useEffect(() => {
    dispatch(setSubpage(CalculationDetailSubpages.REQUEST_LIST_STATISTICS));
  }, [dispatch]);

  return (
    <>
      <Helmet title={`Calculation ${templateOrCalculation.id} - Request List Statistics`} />
      <MainContentWrapper $flexDirection="column">
        <MainContent>
          {requestList && (
            <Section data-id="StatisticsRequestLists" id="StatisticsRequestListsSection">
              <Spin spinning={isFetching}>
                <RequestListStatisticsGuard>
                  <SectionRequestList
                    title={`Request list statistics - ${requestList.name ?? ''}`}
                  />
                </RequestListStatisticsGuard>
              </Spin>
            </Section>
          )}
        </MainContent>
      </MainContentWrapper>
    </>
  );
};

export default CalculationRequestListStatistics;
